import { Locale } from '@superbet-group/web.types';

export type Device =
    | 'MOBILE'
    | 'DESKTOP'
    | 'TABLET';

export const BetGeniusRegion = {
    [Locale.Romanian]: 'RO',
    [Locale.Polish]: 'PL',
    [Locale.Serbian]: 'RS',
    [Locale.PortugueseBrazilian]: 'BR',
    [Locale.EnglishBrazilian]: 'BR',
    [Locale.DutchBelgian]: 'BE',
    [Locale.FrenchBelgian]: 'BE',
    [Locale.EnglishBelgian]: 'BE',
} as const;

export type BetGeniusSupportedLocale = keyof typeof BetGeniusRegion;

export type BetGeniusRequest = {
    fixtureId: string;
    deliveryType: string;
    streamId: string;
    deliveryId: string;
    device: Device;
    userId: string;
    region: Locale;
};

export type BetGeniusStream = {
    url: string;
    expiresAt: string;
    token: string;
    drm: unknown;
};

export type BetGeniusError = {
    error: true;
    notice: string;
};

export function isSupportedBetGeniusLocale(locale: Locale): locale is BetGeniusSupportedLocale {
    return locale in BetGeniusRegion;
}

export function getBetGeniusRegion(locale: Locale) {
    if (isSupportedBetGeniusLocale(locale)) {
        return BetGeniusRegion[locale];
    }

    return BetGeniusRegion[Locale.Romanian];
}

export function isBetGeniusError(input: BetGeniusStream | BetGeniusError): input is BetGeniusError {
    return Boolean((input as BetGeniusError).error);
}
